export const MOCK_GOODS = [
  {
    SellerId: 'anyone',
    StoreName: '모니터링 상품 예시',
    GoodsNo: 'example',
    GoodsName: '털보네 껍질째먹는 꿀사과 흠집사과 못난이 흠과 4kg',
    GoodsPrice: 40000,
    GoodsUrl: 'https://smartstore.naver.com/skyapples/products/5816699527',
    GoodsImageUrl:
      'https://shop-phinf.pstatic.net/20220104_135/16412776242302KFhT_JPEG/42413512892774386_924449894.JPG',
    CategoryFullName: '식품>농산물>과일>사과',
    RelatedKeyword: ['껍질째먹는사과', '사과10kg', '털보네', '꿀사과'],
    RegisteredDate: '2024-06-26T16:43:48',
    PriceChangedStatus: '변화없음',
    SalesChangedStatus: '동일',
    RankingChangedStatus: '변화있음',
    NoticeYn: 'Y',
    UseYn: 'Y',
    IsRemovedGoods: false,
    IsSellerboxProduct: false,
    IsIncompleteGoods: false,
    ComparisonGoodsUrl: '',
    ShippingFee: 0,
    GoodsRegisterDate: '2021-08-26T11:58:55',
    IsMyStoreGoods: false,
    IsDisplayStopped: false,
    MonitoringGoodsDetailDailyList: [
      {
        MonitoringDate: '2025-07-03T00:00:00',
        MonitoringGoodsPrice: 40000,
        MonitoringGoodsName: '털보네 껍질째먹는 꿀사과 흠집사과 못난이 흠과 4kg',
        MonitoringGoodsImageUrl:
          'https://shop-phinf.pstatic.net/20220104_135/16412776242302KFhT_JPEG/42413512892774386_924449894.JPG',
        MonitoringCategoryFullName: '식품>농산물>과일>사과',
        MonitoringRecent3DaySalesCount: 0,
        MonitoringRecent6MonthSalesCount: 0,
        RankingChangedCount: 3,
        RelatedKeywordsRanking: [
          {
            Keyword: '사과10kg',
            Rank: 10,
            PagePosition: '10위 (1페이지 10번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 6,
          },
          {
            Keyword: '껍질째먹는사과',
            Rank: 2,
            PagePosition: '2위 (1페이지 2번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 5,
          },
          {
            Keyword: '꿀사과',
            Rank: 10,
            PagePosition: '10위 (1페이지 10번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 3,
          },
          {
            Keyword: '털보네',
            Rank: 1,
            PagePosition: '1위 (1페이지 1번째)',
            RankingChangedStatus: 'stay',
            RankingChangedRange: 0,
          },
        ],
        PriceChangedStatus: 'stay',
        SalesChangedStatus: 'stay',
        MonitoringTotalReviewCount: 33658,
        MonitoringTotalReviewCountChangedRange: 15,
        MonitoringReviewScore: 4.58,
        MonitoringReviewCountList: [
          {
            Score: 5,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 4,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 3,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 2,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 1,
            Count: 0,
            ChangedRange: 0,
          },
        ],
      },
      {
        MonitoringDate: '2025-07-02T00:00:00',
        MonitoringGoodsPrice: 40000,
        MonitoringGoodsName: '털보네 껍질째먹는 꿀사과 흠집사과 못난이 흠과 4kg',
        MonitoringGoodsImageUrl:
          'https://shop-phinf.pstatic.net/20220104_135/16412776242302KFhT_JPEG/42413512892774386_924449894.JPG',
        MonitoringCategoryFullName: '식품>농산물>과일>사과',
        MonitoringRecent3DaySalesCount: 0,
        MonitoringRecent6MonthSalesCount: 0,
        RankingChangedCount: 2,
        RelatedKeywordsRanking: [
          {
            Keyword: '사과10kg',
            Rank: 16,
            PagePosition: '16위 (1페이지 16번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 2,
          },
          {
            Keyword: '꿀사과',
            Rank: 13,
            PagePosition: '13위 (1페이지 13번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 1,
          },
          {
            Keyword: '털보네',
            Rank: 1,
            PagePosition: '1위 (1페이지 1번째)',
            RankingChangedStatus: 'stay',
            RankingChangedRange: 0,
          },
          {
            Keyword: '껍질째먹는사과',
            Rank: 7,
            PagePosition: '7위 (1페이지 7번째)',
            RankingChangedStatus: 'stay',
            RankingChangedRange: 0,
          },
        ],
        PriceChangedStatus: 'stay',
        SalesChangedStatus: 'stay',
        MonitoringTotalReviewCount: 33643,
        MonitoringTotalReviewCountChangedRange: 12,
        MonitoringReviewScore: 4.58,
        MonitoringReviewCountList: [
          {
            Score: 5,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 4,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 3,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 2,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 1,
            Count: 0,
            ChangedRange: 0,
          },
        ],
      },
      {
        MonitoringDate: '2025-07-01T00:00:00',
        MonitoringGoodsPrice: 40000,
        MonitoringGoodsName: '털보네 껍질째먹는 꿀사과 흠집사과 못난이 흠과 4kg',
        MonitoringGoodsImageUrl:
          'https://shop-phinf.pstatic.net/20220104_135/16412776242302KFhT_JPEG/42413512892774386_924449894.JPG',
        MonitoringCategoryFullName: '식품>농산물>과일>사과',
        MonitoringRecent3DaySalesCount: 0,
        MonitoringRecent6MonthSalesCount: 0,
        RankingChangedCount: 2,
        RelatedKeywordsRanking: [
          {
            Keyword: '껍질째먹는사과',
            Rank: 7,
            PagePosition: '7위 (1페이지 7번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 4,
          },
          {
            Keyword: '꿀사과',
            Rank: 14,
            PagePosition: '14위 (1페이지 14번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 4,
          },
          {
            Keyword: '털보네',
            Rank: 1,
            PagePosition: '1위 (1페이지 1번째)',
            RankingChangedStatus: 'stay',
            RankingChangedRange: 0,
          },
          {
            Keyword: '사과10kg',
            Rank: 18,
            PagePosition: '18위 (1페이지 18번째)',
            RankingChangedStatus: 'stay',
            RankingChangedRange: 0,
          },
        ],
        PriceChangedStatus: 'stay',
        SalesChangedStatus: 'stay',
        MonitoringTotalReviewCount: 33631,
        MonitoringTotalReviewCountChangedRange: 11,
        MonitoringReviewScore: 4.58,
        MonitoringReviewCountList: [
          {
            Score: 5,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 4,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 3,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 2,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 1,
            Count: 0,
            ChangedRange: 0,
          },
        ],
      },
      {
        MonitoringDate: '2025-06-30T00:00:00',
        MonitoringGoodsPrice: 40000,
        MonitoringGoodsName: '털보네 껍질째먹는 꿀사과 흠집사과 못난이 흠과 4kg',
        MonitoringGoodsImageUrl:
          'https://shop-phinf.pstatic.net/20220104_135/16412776242302KFhT_JPEG/42413512892774386_924449894.JPG',
        MonitoringCategoryFullName: '식품>농산물>과일>사과',
        MonitoringRecent3DaySalesCount: 0,
        MonitoringRecent6MonthSalesCount: 0,
        RankingChangedCount: 2,
        RelatedKeywordsRanking: [
          {
            Keyword: '껍질째먹는사과',
            Rank: 11,
            PagePosition: '11위 (1페이지 11번째)',
            RankingChangedStatus: 'down',
            RankingChangedRange: -3,
          },
          {
            Keyword: '꿀사과',
            Rank: 18,
            PagePosition: '18위 (1페이지 18번째)',
            RankingChangedStatus: 'down',
            RankingChangedRange: -3,
          },
          {
            Keyword: '털보네',
            Rank: 1,
            PagePosition: '1위 (1페이지 1번째)',
            RankingChangedStatus: 'stay',
            RankingChangedRange: 0,
          },
          {
            Keyword: '사과10kg',
            Rank: 18,
            PagePosition: '18위 (1페이지 18번째)',
            RankingChangedStatus: 'stay',
            RankingChangedRange: 0,
          },
        ],
        PriceChangedStatus: 'stay',
        SalesChangedStatus: 'stay',
        MonitoringTotalReviewCount: 33620,
        MonitoringTotalReviewCountChangedRange: 15,
        MonitoringReviewScore: 4.58,
        MonitoringReviewCountList: [
          {
            Score: 5,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 4,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 3,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 2,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 1,
            Count: 0,
            ChangedRange: 0,
          },
        ],
      },
      {
        MonitoringDate: '2025-06-29T00:00:00',
        MonitoringGoodsPrice: 40000,
        MonitoringGoodsName: '털보네 껍질째먹는 꿀사과 흠집사과 못난이 흠과 4kg',
        MonitoringGoodsImageUrl:
          'https://shop-phinf.pstatic.net/20220104_135/16412776242302KFhT_JPEG/42413512892774386_924449894.JPG',
        MonitoringCategoryFullName: '식품>농산물>과일>사과',
        MonitoringRecent3DaySalesCount: 0,
        MonitoringRecent6MonthSalesCount: 0,
        RankingChangedCount: 3,
        RelatedKeywordsRanking: [
          {
            Keyword: '꿀사과',
            Rank: 15,
            PagePosition: '15위 (1페이지 15번째)',
            RankingChangedStatus: 'down',
            RankingChangedRange: -2,
          },
          {
            Keyword: '껍질째먹는사과',
            Rank: 8,
            PagePosition: '8위 (1페이지 8번째)',
            RankingChangedStatus: 'down',
            RankingChangedRange: -1,
          },
          {
            Keyword: '사과10kg',
            Rank: 18,
            PagePosition: '18위 (1페이지 18번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 1,
          },
          {
            Keyword: '털보네',
            Rank: 1,
            PagePosition: '1위 (1페이지 1번째)',
            RankingChangedStatus: 'stay',
            RankingChangedRange: 0,
          },
        ],
        PriceChangedStatus: 'stay',
        SalesChangedStatus: 'stay',
        MonitoringTotalReviewCount: 33605,
        MonitoringTotalReviewCountChangedRange: 11,
        MonitoringReviewScore: 4.58,
        MonitoringReviewCountList: [
          {
            Score: 5,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 4,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 3,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 2,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 1,
            Count: 0,
            ChangedRange: 0,
          },
        ],
      },
      {
        MonitoringDate: '2025-06-28T00:00:00',
        MonitoringGoodsPrice: 40000,
        MonitoringGoodsName: '털보네 껍질째먹는 꿀사과 흠집사과 못난이 흠과 4kg',
        MonitoringGoodsImageUrl:
          'https://shop-phinf.pstatic.net/20220104_135/16412776242302KFhT_JPEG/42413512892774386_924449894.JPG',
        MonitoringCategoryFullName: '식품>농산물>과일>사과',
        MonitoringRecent3DaySalesCount: 0,
        MonitoringRecent6MonthSalesCount: 0,
        RankingChangedCount: 1,
        RelatedKeywordsRanking: [
          {
            Keyword: '사과10kg',
            Rank: 19,
            PagePosition: '19위 (1페이지 19번째)',
            RankingChangedStatus: 'down',
            RankingChangedRange: -1,
          },
          {
            Keyword: '털보네',
            Rank: 1,
            PagePosition: '1위 (1페이지 1번째)',
            RankingChangedStatus: 'stay',
            RankingChangedRange: 0,
          },
          {
            Keyword: '껍질째먹는사과',
            Rank: 7,
            PagePosition: '7위 (1페이지 7번째)',
            RankingChangedStatus: 'stay',
            RankingChangedRange: 0,
          },
          {
            Keyword: '꿀사과',
            Rank: 13,
            PagePosition: '13위 (1페이지 13번째)',
            RankingChangedStatus: 'stay',
            RankingChangedRange: 0,
          },
        ],
        PriceChangedStatus: 'stay',
        SalesChangedStatus: 'stay',
        MonitoringTotalReviewCount: 33594,
        MonitoringTotalReviewCountChangedRange: 9,
        MonitoringReviewScore: 4.58,
        MonitoringReviewCountList: [
          {
            Score: 5,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 4,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 3,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 2,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 1,
            Count: 0,
            ChangedRange: 0,
          },
        ],
      },
      {
        MonitoringDate: '2025-06-27T00:00:00',
        MonitoringGoodsPrice: 40000,
        MonitoringGoodsName: '털보네 껍질째먹는 꿀사과 흠집사과 못난이 흠과 4kg',
        MonitoringGoodsImageUrl:
          'https://shop-phinf.pstatic.net/20220104_135/16412776242302KFhT_JPEG/42413512892774386_924449894.JPG',
        MonitoringCategoryFullName: '식품>농산물>과일>사과',
        MonitoringRecent3DaySalesCount: 0,
        MonitoringRecent6MonthSalesCount: 0,
        RankingChangedCount: 4,
        RelatedKeywordsRanking: [
          {
            Keyword: '털보네',
            Rank: 1,
            PagePosition: '1위 (1페이지 1번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 1,
          },
          {
            Keyword: '껍질째먹는사과',
            Rank: 7,
            PagePosition: '7위 (1페이지 7번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 1,
          },
          {
            Keyword: '꿀사과',
            Rank: 13,
            PagePosition: '13위 (1페이지 13번째)',
            RankingChangedStatus: 'down',
            RankingChangedRange: -1,
          },
          {
            Keyword: '사과10kg',
            Rank: 18,
            PagePosition: '18위 (1페이지 18번째)',
            RankingChangedStatus: 'down',
            RankingChangedRange: -1,
          },
        ],
        PriceChangedStatus: 'stay',
        SalesChangedStatus: 'stay',
        MonitoringTotalReviewCount: 33585,
        MonitoringTotalReviewCountChangedRange: 17,
        MonitoringReviewScore: 4.58,
        MonitoringReviewCountList: [
          {
            Score: 5,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 4,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 3,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 2,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 1,
            Count: 0,
            ChangedRange: 0,
          },
        ],
      },
      {
        MonitoringDate: '2025-06-26T00:00:00',
        MonitoringGoodsPrice: 40000,
        MonitoringGoodsName: '털보네 껍질째먹는 꿀사과 흠집사과 못난이 흠과 4kg',
        MonitoringGoodsImageUrl:
          'https://shop-phinf.pstatic.net/20220104_135/16412776242302KFhT_JPEG/42413512892774386_924449894.JPG',
        MonitoringCategoryFullName: '식품>농산물>과일>사과',
        MonitoringRecent3DaySalesCount: 0,
        MonitoringRecent6MonthSalesCount: 0,
        RankingChangedCount: 1,
        RelatedKeywordsRanking: [
          {
            Keyword: '꿀사과',
            Rank: 12,
            PagePosition: '12위 (1페이지 12번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 1,
          },
          {
            Keyword: '털보네',
            Rank: 2,
            PagePosition: '2위 (1페이지 2번째)',
            RankingChangedStatus: 'stay',
            RankingChangedRange: 0,
          },
          {
            Keyword: '껍질째먹는사과',
            Rank: 8,
            PagePosition: '8위 (1페이지 8번째)',
            RankingChangedStatus: 'stay',
            RankingChangedRange: 0,
          },
          {
            Keyword: '사과10kg',
            Rank: 17,
            PagePosition: '17위 (1페이지 17번째)',
            RankingChangedStatus: 'stay',
            RankingChangedRange: 0,
          },
        ],
        PriceChangedStatus: 'stay',
        SalesChangedStatus: 'stay',
        MonitoringTotalReviewCount: 33568,
        MonitoringTotalReviewCountChangedRange: 3,
        MonitoringReviewScore: 4.58,
        MonitoringReviewCountList: [
          {
            Score: 5,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 4,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 3,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 2,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 1,
            Count: 0,
            ChangedRange: 0,
          },
        ],
      },
      {
        MonitoringDate: '2025-06-25T00:00:00',
        MonitoringGoodsPrice: 40000,
        MonitoringGoodsName: '털보네 껍질째먹는 꿀사과 흠집사과 못난이 흠과 4kg',
        MonitoringGoodsImageUrl:
          'https://shop-phinf.pstatic.net/20220104_135/16412776242302KFhT_JPEG/42413512892774386_924449894.JPG',
        MonitoringCategoryFullName: '식품>농산물>과일>사과',
        MonitoringRecent3DaySalesCount: 0,
        MonitoringRecent6MonthSalesCount: 0,
        RankingChangedCount: 4,
        RelatedKeywordsRanking: [
          {
            Keyword: '털보네',
            Rank: 2,
            PagePosition: '2위 (1페이지 2번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 0,
          },
          {
            Keyword: '껍질째먹는사과',
            Rank: 8,
            PagePosition: '8위 (1페이지 8번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 0,
          },
          {
            Keyword: '꿀사과',
            Rank: 13,
            PagePosition: '13위 (1페이지 13번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 0,
          },
          {
            Keyword: '사과10kg',
            Rank: 17,
            PagePosition: '17위 (1페이지 17번째)',
            RankingChangedStatus: 'up',
            RankingChangedRange: 0,
          },
        ],
        PriceChangedStatus: 'stay',
        SalesChangedStatus: 'stay',
        MonitoringTotalReviewCount: 33565,
        MonitoringTotalReviewCountChangedRange: 13,
        MonitoringReviewScore: 4.58,
        MonitoringReviewCountList: [
          {
            Score: 5,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 4,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 3,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 2,
            Count: 0,
            ChangedRange: 0,
          },
          {
            Score: 1,
            Count: 0,
            ChangedRange: 0,
          },
        ],
      },
    ],
    MonitoringGoodsMyDetail: {
      GoodsUrl: '',
      GoodsNo: '',
      GoodsName: '',
      GoodsImageUrl: '',
      CategoryFullName: '',
      GoodsPrice: 0,
      GoodsPriceChangedStatus: '',
      MonitoringRecent7DaySalesCount: 0,
      MonitoringRecent7DaySalesCountChangedStatus: '',
      MonitoringRecent6MonthSalesCount: 0,
      MonitoringRecent6MonthSalesCountChangedStatus: '',
      MonitoringRecentMonthSalesAmount: 0,
      MonitoringRecentMonthSalesAmountChangedStatus: '',
      ReviewCount: 0,
      ReviewCountChangedStatus: '',
      ReviewAverage: 0,
      ReviewAverageChangedStatus: '',
    },
    MonitoringGoodsComparisonDetail: {
      GoodsUrl: '',
      GoodsNo: '',
      GoodsName: '',
      GoodsImageUrl: '',
      CategoryFullName: '',
      GoodsPrice: 0,
      GoodsPriceChangedStatus: '',
      MonitoringRecent7DaySalesCount: 0,
      MonitoringRecent7DaySalesCountChangedStatus: '',
      MonitoringRecent6MonthSalesCount: 0,
      MonitoringRecent6MonthSalesCountChangedStatus: '',
      MonitoringRecentMonthSalesAmount: 0,
      MonitoringRecentMonthSalesAmountChangedStatus: '',
      ReviewCount: 0,
      ReviewCountChangedStatus: '',
      ReviewAverage: 0,
      ReviewAverageChangedStatus: '',
    },
  },
];
